import {
	getThemeClass,
	getComponentClass,
	getSeasonalThemeName,
	selectSeasonalValue,
} from './christmasEvent';

/**
 * Token-first UI classes. Colors come from seasonalTheme.css via
 * html[data-seasonal-theme] CSS variables — not per-theme Tailwind maps.
 */
export const themeUi = {
	accent: 'tvx-accent-text',
	accentHover: 'tvx-accent-hover',
	accentUnderline: 'tvx-accent-underline',
	accentOnDark: 'tvx-accent-text',
	price: 'tvx-accent-text',
	iconAccent: 'tvx-accent-text-muted',
	primaryButton: 'tvx-btn-primary shadow-lg',
	contactButton: 'tvx-btn-primary',
	solidControl: 'tvx-btn-primary',
	cardPrimary: 'tvx-btn-primary',
	chipBadge: 'tvx-accent-bg',
	subtleBadge: 'tvx-accent-soft-10-bg tvx-accent-text',
	infoIcon: 'tvx-accent-soft-bg tvx-accent-text',
	softIconBg: 'tvx-accent-soft-bg tvx-accent-border',
	hexagon: 'tvx-accent-fill',
	heroTitle: 'tvx-accent-text',
	heroUnderline: 'tvx-accent-soft-30-bg',
	heroBadge: 'tvx-accent-soft-10-bg tvx-accent-text',
	heroIconBg: 'tvx-accent-bg',
	gradientFrom: 'from-[var(--tvx-accent-muted)]',
	gradientTo: 'to-[var(--tvx-accent)]',
	linkAccent: 'tvx-link tvx-accent-underline',
	focusAccent: 'tvx-focus-ring',
	quoteBorder: 'tvx-accent-border',
	promoCode: 'tvx-promo-code',
	cart: {
		link: 'font-medium tvx-link underline underline-offset-2',
		linkSimple: 'tvx-accent-text font-medium hover:underline',
		linkMuted: 'tvx-accent-text underline underline-offset-2',
		linkLegal: 'tvx-accent-text',
		focusRing: 'tvx-focus-ring',
		applyButton: 'tvx-btn-primary',
		applyButtonDisabled: 'tvx-btn-primary opacity-70 cursor-not-allowed',
		softPanel: 'tvx-soft-panel',
		checkbox: 'tvx-peer-checked-accent',
		emptyIconWrap: 'tvx-accent-border tvx-accent-soft-10-bg',
		emptyIcon: 'tvx-accent-text',
		ctaButton: 'tvx-btn-primary',
		ctaButtonDisabled: '',
		optionActive: 'tvx-option-active shadow-sm',
		optionIdle: 'tvx-option-idle hover:border-gray-400 hover:bg-gray-50',
		optionIcon: 'border-gray-200 bg-gray-50 text-gray-600 tvx-accent-soft-10-bg tvx-accent-text',
		optionBadge: 'border-gray-200 bg-gray-50 text-gray-600 tvx-accent-soft-10-bg tvx-accent-text',
		selectedChip: 'tvx-chip-selected',
		helperText: 'tvx-accent-text-muted',
		progressBar: 'tvx-progress-bar',
		successRing: 'tvx-success-ring',
		successGlow: 'tvx-success-glow',
		successIcon: 'tvx-success-icon',
		stepBadge: 'tvx-soft-panel tvx-accent-text',
		toastLink: 'tvx-link',
		toastLinkDark: 'tvx-accent-text-muted hover:tvx-accent-text',
		confettiColors: selectSeasonalValue({
			default: ['#6366f1', '#818cf8', '#38bdf8', '#22d3ee', '#34d399', '#a3e635', '#fbbf24', '#fb7185', '#c084fc', '#60a5fa'],
			christmas: ['#dc2626', '#ef4444', '#22c55e', '#16a34a', '#fbbf24', '#f87171', '#86efac', '#fde68a', '#b91c1c', '#4ade80'],
			halloween: ['#f97316', '#fb923c', '#7c3aed', '#a855f7', '#eab308', '#fbbf24', '#f59e0b', '#c084fc', '#ea580c', '#fde047'],
			easter: ['#db2777', '#ec4899', '#a855f7', '#8b5cf6', '#f472b6', '#c084fc', '#f9a8d4', '#22d3ee', '#fbbf24', '#86efac'],
		}),
		burstColors: selectSeasonalValue({
			default: ['bg-indigo-400', 'bg-pink-400', 'bg-cyan-400', 'bg-amber-400', 'bg-emerald-400', 'bg-white'],
			christmas: ['bg-red-400', 'bg-emerald-400', 'bg-amber-400', 'bg-rose-400', 'bg-green-400', 'bg-white'],
			halloween: ['bg-orange-400', 'bg-amber-400', 'bg-purple-400', 'bg-yellow-400', 'bg-violet-400', 'bg-white'],
			easter: ['bg-pink-400', 'bg-fuchsia-400', 'bg-violet-400', 'bg-rose-400', 'bg-purple-400', 'bg-white'],
		}),
	},
};

/** Optional escape hatch when a page still reads christmasEvent class maps. */
export const themeClass = (path, fallback = '') => getThemeClass(path, fallback);

export const applySeasonalThemeToDocument = () => {
	if (typeof document === 'undefined') return;
	const name = getSeasonalThemeName();
	document.documentElement.dataset.seasonalTheme = name || 'default';
	if (name === 'halloween' && getComponentClass('landing.showBatCursor', true)) {
		document.documentElement.dataset.halloweenCursor = 'bat';
	} else {
		delete document.documentElement.dataset.halloweenCursor;
	}
	if (name === 'christmas' && getComponentClass('landing.showSnowflakeCursor', true)) {
		document.documentElement.dataset.xmasCursor = 'snowflake';
	} else {
		delete document.documentElement.dataset.xmasCursor;
	}
};
